import React from 'react';

const BB8 = (props) => {
  const { radius, cells } = props;
  const width = 556 * (radius / 370); //radius;
  const height = 419 * (radius / 370); // radius;

  const base = cells[8].background;
  const light = cells[2].background;
  const dark = cells[1].background;

  return (
    <svg width={`${width}px`} height={`${height}px`} x={-width / 1.9 - 40} y={-height * 1.8} viewBox="-27 -46 566 419" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <defs>
          <path d="M512,286.739159 C512,128.377494 397.384896,0 256,0 C114.615104,0 0,128.377494 0,286.739159 L512,286.739159 Z" id="path-1"></path>
      </defs>
      
      <g id="Group-2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(256.000000, 163.500000) rotate(-11.000000) translate(-256.000000, -163.500000) ">
          <polygon id="Path-12" fill={light} points="6 279 55.5942723 326.345594 457.440958 326.345594 506.722673 279"></polygon>
          <mask id="mask-2" fill="white">
              <use xlinkHref="#path-1"></use>
          </mask>
          <use id="Mask" fill={light} xlinkHref="#path-1"></use>
          <rect id="Rectangle" fill={base} mask="url(#mask-2)" x="55.4067847" y="86.7738756" width="400" height="20"></rect>
          <rect id="Rectangle" fill={dark} mask="url(#mask-2)" x="63.6115715" y="44.5639067" width="400" height="20"></rect>
          <circle id="Oval-2" fill="#464646" mask="url(#mask-2)" cx="212.5" cy="139.5" r="67.5"></circle>
          <circle id="Oval-5" stroke={dark} strokeWidth="10" mask="url(#mask-2)" cx="317.5" cy="217.5" r="44.5"></circle>
          <circle id="Oval-3" fill="#464646" mask="url(#mask-2)" cx="317.5" cy="217.5" r="28.5"></circle>
      </g>
    </svg>
  )
}
export default BB8;

export function resize(props) {
  const {radius, minY} = props;
  const height = 556 * (radius / 620);
  return {
    ...props,
    minY: minY + height,
  };
}


// WEBPACK FOOTER //
// ./src/core/thematic/bb8/index.js